import { io } from "socket.io-client"

import { AbstractService } from "services/abstract.service";

export class SocketsService extends AbstractService<void>
{
    public status: string = "connecting"; // The status of the sockets connection.

    /**
     * Constructor
     */
    public constructor()
    {
        console.log(`[Sockets Service] Connecting to server at ${process.env.REACT_APP_SERVER_URL ?? ""}...`);
        super(io(process.env.REACT_APP_SERVER_URL ?? "", {
            transports: ["websocket"],
        }));

        // Connection:
        this.socket.on("connect", () => {
            console.log("[Sockets Service] Connected to server.");
            this.status = "connected";
            this.listeners.forEach(listener => listener("connect"));
        });

        this.socket.on("connect_error", (err) => {
            console.log(`[Sockets Service] Connection error: ${err.message}`);
            this.status = "error";
            this.listeners.forEach(listener => listener("connect_error"));
        });

        this.socket.on("disconnect", (err) => {
            console.log("[Sockets Service] Disconnected from server.");
            this.status = "disconnected";
            this.listeners.forEach(listener => listener("disconnect"));
        });
    }

    /**
     * Forces a disconnect, can be used to logout.
     */
    public disconnect(): void
    {
        console.log("[Sockets Service] Disconnecting from server...");
        this.socket.disconnect();
        this.socket.connect();
    }
}